export interface IUserProfileModal {
  isOpen: boolean;
  onClose: () => void;
}

export enum ProfileScreensEnum {
  DEFAULT = 'DEFAULT',
  SETTINGS = 'SETTINGS',
  SETTINGS_LANGUAGE = 'SETTINGS_LANGUAGE',
}
